/**
 * Operation Domain Types
 * Defines types for banking operations/transactions
 */
/**
 * Available columns for export with their display labels
 */
export const EXPORT_COLUMNS = [
    { key: 'paymentDate', labelKey: 'export.columns.paymentDate' },
    { key: 'accountingDate', labelKey: 'export.columns.accountingDate' },
    { key: 'direction', labelKey: 'export.columns.direction' },
    { key: 'amount', labelKey: 'export.columns.amount' },
    { key: 'counterpartyName', labelKey: 'export.columns.counterparty' },
    { key: 'categoryNames', labelKey: 'export.columns.categories' },
    { key: 'paymentMethodName', labelKey: 'export.columns.paymentMethod' },
    { key: 'paymentDetails', labelKey: 'export.columns.paymentDetails' },
    { key: 'reference', labelKey: 'export.columns.reference' },
    { key: 'comment', labelKey: 'export.columns.comment' },
    { key: 'status', labelKey: 'export.columns.status' },
];
//# sourceMappingURL=operation.js.map